module.exports = __webpack_public_path__ + "img/toabo-logo.864726e1.png";